import FAQ from "./FAQ";

const faqs = [
  {
    question: "Who can join the affiliate program?",
    answer: "Anyone with a Flowstep account. You can join on the free plan.",
  },
  {
    question: "How do I join?",
    answer:
      "Create a Flowstep account, then open the in-app affiliate dashboard via the settings page and enroll.",
  },
  {
    question: "Where do I get my referral link?",
    answer: "Inside Flowstep, in your affiliate dashboard.",
  },
  {
    question: "What do I earn?",
    answer:
      "20% commission on what your referrals pay for their first 3 months, paid monthly. All paid plans are eligible for commission.",
  },
  {
    question: "What do my referrals get?",
    answer: "$5 off their first purchase.",
  },
  {
    question: "How is a referral tracked?",
    answer:
      "Via a unique referral link and a 30-day tracking cookie. The referral is attributed on account creation. It never changes after that.",
  },
  {
    question: "Do I get paid if they cancel or get a refund?",
    answer:
      "No. Refunds or chargebacks during the holding period cancel the reward.",
  },
  {
    question: "When do I get paid?",
    answer:
      "Once per month, within 14 days after the 30-day holding period ends. There is no minimum balance required.",
  },
  {
    question: "Where can I track my performance?",
    answer:
      "In Flowstep, in your affiliate dashboard. You'll find this on the settings page. You can see clicks, signups, and earnings in real-time.",
  },
];

export function AffiliatesFAQ() {
  return <FAQ faqs={faqs} />;
}
